module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/channel-chatbot-d990e5ffa61316da2ff1add8099e4143.svg";